import Cookies from 'js-cookie';
import SearchInsights, {
  ViewedObjectIDs,
  ViewedFilters,
  ClickedObjectIDs,
  ClickedFilters,
  ConvertedObjectIDs,
} from 'search-insights';
import { TSFixMe } from '@yi/core';

import { notifyBugsnag } from './bugsnagClient';

type ConvertedObjectIDsAfterSearch = {
  userToken?: string;
  timestamp?: number;
  index?: string;
  queryID?: string;
  objectIDs?: (string | number)[];
  eventName: string;
  type: 'convertedObjectIDsAfterSearch';
};
type ClickedObjectIDsAfterSearch = {
  eventName: string;
  userToken?: string;
  timestamp?: number;
  index: string;
  queryID: string;
  objectIDs: (string | number)[];
  positions: number[];
  type: 'clickedObjectIDsAfterSearch';
};
type ClickedObjectIDsType = Parameters<ClickedObjectIDs>[1] & {
  type: 'clickedObjectIDs';
};
type ViewedObjectIDsType = Parameters<ViewedObjectIDs>[1] & {
  type: 'viewedObjectIDs';
};
type ViewedFiltersType = Parameters<ViewedFilters>[1] & {
  type: 'viewedFilters';
};
type ClickedFiltersType = Parameters<ClickedFilters>[1] & {
  type: 'clickedFilters';
};
type ConvertedObjectIDsType = Parameters<ConvertedObjectIDs>[1] & {
  type: 'convertedObjectIDs';
};
type EventTypes =
  | ConvertedObjectIDsAfterSearch
  | ClickedObjectIDsAfterSearch
  | ClickedObjectIDsType
  | ViewedObjectIDsType
  | ViewedFiltersType
  | ClickedFiltersType
  | ConvertedObjectIDsType;
type SearchInsightsCookies = {
  queryID: string;
  indexName: string;
  contentID: string;
};
type ProductClickedEvent = {
  queryID?: string;
  indexName: string;
  contentID: string;
  position?: number;
};

export const getSearchInsightsCookies = () => {
  const indexName = Cookies.get('searchInsightsIndexName') || '';
  const queryID = Cookies.get('searchInsightsQueryID') || '';
  const contentID = Cookies.get('searchInsightsContentID');

  return { indexName, queryID, contentID };
};
export const setSearchInsightsCookies = ({
  queryID,
  indexName,
  contentID,
}: SearchInsightsCookies) => {
  const thirtyMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);
  Cookies.set('searchInsightsQueryID', queryID, { expires: thirtyMinutes });
  Cookies.set('searchInsightsIndexName', indexName, { expires: thirtyMinutes });
  Cookies.set('searchInsightsContentID', contentID, { expires: thirtyMinutes });
};
export const logAlgoliaProductClickedEvent = ({
  contentID,
  indexName,
  queryID,
  position,
}: ProductClickedEvent) => {
  if (queryID) setSearchInsightsCookies({ queryID, indexName, contentID });
  if (queryID && position) {
    logSearchInsightsEvent({
      eventName: 'Product Clicked',
      type: 'clickedObjectIDsAfterSearch',
      index: indexName,
      queryID,
      objectIDs: [contentID],
      positions: [position],
    });
  } else {
    logSearchInsightsEvent({
      eventName: 'Product Clicked',
      type: 'clickedObjectIDs',
      index: indexName,
      objectIDs: [contentID],
    });
  }
};
/**
 * don't call the logSearchInsightsEvent events if algoliaToken from SearchInsightsProvider in calling component is empty
 */
// TS cannot resolve  EventTypes properly
export function logSearchInsightsEvent(event: EventTypes | TSFixMe) {
  const { eventName } = event;
  const { indexName, queryID, contentID } = getSearchInsightsCookies();
  const index = event.index || indexName;
  let objectIDs: string[] = [];
  if (event.type !== 'clickedFilters' && event.type !== 'viewedFilters') {
    const eventObjectIDs: string[] | undefined = event.objectIDs
      ? event.objectIDs.map((id: unknown) => String(id))
      : undefined;
    objectIDs = eventObjectIDs || (contentID && [String(contentID)]) || [];
    if (!objectIDs.length) return;
  }
  const timestamp = new Date().getTime();
  if (!index) return;
  try {
    switch (event.type) {
      case 'viewedObjectIDs': {
        const { objectIDs: objectIDs_ } = event;
        SearchInsights(event.type, {
          index,
          eventName,
          objectIDs: objectIDs_,
          timestamp,
        });
        break;
      }
      case 'clickedObjectIDs':
        SearchInsights(event.type, {
          index,
          eventName,
          objectIDs,
          timestamp,
        });
        break;
      case 'convertedObjectIDs':
        SearchInsights(event.type, {
          index,
          eventName,
          objectIDs,
          timestamp,
        });
        break;
      case 'viewedFilters': {
        const { filters } = event;
        if (filters.length)
          SearchInsights(event.type, {
            index,
            eventName,
            filters,
            timestamp,
          });
        break;
      }
      case 'clickedFilters': {
        const { filters } = event;
        if (filters.length)
          SearchInsights(event.type, {
            index,
            eventName,
            filters,
            timestamp,
          });
        break;
      }
      case 'clickedObjectIDsAfterSearch': {
        const { positions } = event;
        const queryID_ = event.queryID || queryID;
        if (queryID_ && positions)
          SearchInsights(event.type, {
            eventName,
            index,
            queryID: queryID_,
            objectIDs,
            positions,
            timestamp,
          });
        break;
      }
      case 'convertedObjectIDsAfterSearch': {
        const queryID_ = event.queryID || queryID;
        if (queryID_)
          SearchInsights(event.type, {
            index,
            eventName,
            queryID: queryID_,
            objectIDs,
            timestamp,
          });
        else
          logSearchInsightsEvent({
            index,
            eventName,
            objectIDs,
            timestamp,
            type: 'convertedObjectIDs',
          });
        break;
      }
      default:
        console.log('invalid event');
    }
  } catch (e) {
    console.error(e);
    notifyBugsnag(e);
  }
}
